export const STATE_CLICKABLE = 'clickable';
export const STATE_LOADING = 'loading';

export const CSS_CLASS_TITLE = 'card-title';
export const CSS_CLASS_BODY = 'card-body';
export const CSS_CLASS_LOADING = 'card-loading';

export const SLOT_TITLE = 'title';

export const DATA_TITLE_ICON = 'title-icon';
export const DATA_TITLE_TEXT = 'title-text';
export const DATA_TITLE_LINK = 'title-link';

export const EVENT_LOADING = 'bnum-card:loading';
export const EVENT_CLICK = 'bnum-card:click';

export const ICON_SPINNER = 'progress_activity';
